import { render, staticRenderFns } from "./AddressForReward.vue?vue&type=template&id=e3bfcfc6&"
import script from "./AddressForReward.vue?vue&type=script&lang=js&"
export * from "./AddressForReward.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports